import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/nocowaniedev/frontend/frontend/apps/nocowanie-ssr/app/client-layout.tsx");
;
import(/* webpackMode: "eager" */ "/builds/nocowaniedev/frontend/frontend/apps/nocowanie-ssr/components/atoms/third-party-scripts/third-party-scripts.tsx");
;
import(/* webpackMode: "eager" */ "/builds/nocowaniedev/frontend/frontend/apps/nocowanie-ssr/components/providers/store-provider/store.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/builds/nocowaniedev/frontend/frontend/node_modules/@chakra-ui/react/dist/esm/components/box/box.js");
;
import(/* webpackMode: "eager", webpackExports: ["createIcon"] */ "/builds/nocowaniedev/frontend/frontend/node_modules/@chakra-ui/react/dist/esm/components/icon/create-icon.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSlotRecipe"] */ "/builds/nocowaniedev/frontend/frontend/node_modules/@chakra-ui/react/dist/esm/styled-system/use-slot-recipe.js");
;
import(/* webpackMode: "eager" */ "/builds/nocowaniedev/frontend/frontend/node_modules/next/dist/client/script.js");
